import { GET_ALL_RAMAIS, GET_ALL_FILAS, GET_ALL_PAUSAS, GET_ALL_OPERADORES } from './mutation-types'

export default {
  [GET_ALL_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
  [GET_ALL_PAUSAS]: (state, pausas) => {
    state.pausas = pausas
  },
  [GET_ALL_FILAS]: (state, filas) => {
    state.filas = filas
  },
  [GET_ALL_OPERADORES]: (state, operadores) => {
    state.operadores = operadores
  },
}
